import React from 'react';

import PieChart, {
  Series,
  Legend,
  Label,
  Connector,
} from 'devextreme-react/pie-chart';


import CenterTemplate from './CenterTemplate2.js';


const data = [
    { country: 'France', commodity: 'نسبة المسجلين ', total: 43 },
    { country: 'France', commodity: 'نسبة الغير مسجلين', total: 57 },
  ];

  const countries = Array.from(new Set(data.map((item) => item.country)));

const DoughnutChart = ()=> {
  const customizeLabel = (e)=> {
    return `${e.argumentText}\n\n${e.valueText}`;
  }

  
   

    return (
      
   
      <PieChart
        id="pie-chart"
        key={countries[0]}
        dataSource={data.filter((i) => i.country === countries[0])}
        resolveLabelOverlapping="shift"
        sizeGroup="piesGroup"
        innerRadius={0.65}
        centerRender={CenterTemplate}
        type="doughnut"
      >
        <Series
          argumentField="commodity"
          valueField="total"
        >
          <Label visible={true}
            format="fixedPoint"
            customizeText={customizeLabel}
            backgroundColor="none">
            <Connector visible={true}></Connector>
          </Label>
        </Series>
        
        <Legend verticalAlignment="top" horizontalAlignment="center"></Legend>
        
      </PieChart>
    );
  
}

export default DoughnutChart;
